export default __webpack_public_path__ + "static/media/kausi17-min.f7c4982c.jpg";